import { useState, useEffect, useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";
import styles from "./styles.module.css";
import MainNavbar from "../../utils/MainNavbar/MainNavbar";
import { ROUTES } from "const";
import ShiftExpiryDialog from "../../popups/ShiftExpiryDialog";
import CloseShiftDialog from "../../popups/CloseShiftDialog/CloseShiftDialog";
import OnlineOrderAlert from "../../utils/OnlineOrderAlert/OnlineOrderAlert";
import OnlineOrderDetailsPopup from "../../popups/OnlineOrderDetailsPopup/OnlineOrderDetailsPopup";
import NotificationContext from "context/NotificationContext";
import * as ShiftHelper from "helpers/ShiftHelper";

function PosLayout() {
  const location = useLocation();
  const notificationContext = useContext(NotificationContext);
  const [showExpiryDialog, setShowExpiryDialog] = useState(false);
  const [showCloseDialog, setShowCloseDialog] = useState(ShiftHelper.isShiftClosing());
  const [hasChecked, setHasChecked] = useState(false);

  const isTableDashboard = location.pathname === ROUTES.TABLE_DASHBOARD;

  useEffect(() => {
    if (!hasChecked) {
      if (ShiftHelper.isShiftOlderThan24Hours() && !ShiftHelper.isShiftExpirySkipped()) {
        setShowExpiryDialog(true);
      }
      setHasChecked(true);
    }
  }, [hasChecked]);

  const handleCreateNewShift = () => {
    setShowExpiryDialog(false);
    setShowCloseDialog(true);
  };

  const handleSkip = () => {
    ShiftHelper.setShiftExpirySkipTime();
    setShowExpiryDialog(false);
  };

  const handleCloseShiftSubmit = () => {
    setShowCloseDialog(false);
  };

  return (
    <div className={styles.container}>
      <div className={`${styles.navbar} ${isTableDashboard ? styles.tableDashboardNavbar : ""}`}>
        <MainNavbar />
      </div>
      <OnlineOrderAlert />
      <div className={styles.ContentsWrapper}>
        <Outlet />
      </div>

      <ShiftExpiryDialog open={showExpiryDialog} onSkip={handleSkip} onCreateNewShift={handleCreateNewShift} />

      <CloseShiftDialog
        open={showCloseDialog}
        onClose={() => setShowCloseDialog(false)}
        onSubmit={handleCloseShiftSubmit}
      />

      {notificationContext?.selectedOrderIdForModal && (
        <OnlineOrderDetailsPopup
          open={Boolean(notificationContext.selectedOrderIdForModal)}
          orderId={notificationContext.selectedOrderIdForModal}
          onClose={notificationContext.closeOnlineOrderDetails}
        />
      )}
    </div>
  );
}

export default PosLayout;
